
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexTypeGrid extends SiteEntityGrid<IndexTypeRow, any> {
        protected getColumnsKey() { return IndexTypeColumns.columnsKey; }
        protected getDialogType() { return IndexTypeDialog; }
        protected getIdProperty() { return IndexTypeRow.idProperty; }
        protected getInsertPermission() { return IndexTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return IndexTypeRow.localTextPrefix; }
        protected getService() { return IndexTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}